import { CHANGE_STATUS, SET_GROUP, UPDATE_GROUP, DELETE_GROUP } from "../constants";

const initialState = [];

export const groupReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case SET_GROUP: {
            state = [...payload];
            return state;
        }
        case CHANGE_STATUS: {
            let temp = [...state];
            let index = temp.findIndex(group => group._id === payload);
            if (index > -1) {
                temp[index].status = temp[index].status === 'Live' ? 'Disabled' : 'Live';
            }
            return temp;
        }
        case UPDATE_GROUP: {
            let temp = [...state];
            let index = temp.findIndex(group => group._id === payload._id);
            if (index > -1) {
                temp[index] = payload;
            }
            return temp;
        }
        case DELETE_GROUP: {
            let temp = [...state];
            let index = temp.findIndex(group => group._id === payload);
            if (index > -1) {
                temp.splice(index, 1);
            }
            return temp;
        }
        default: {
            return state
        }
    }
};